import { Injectable, NgZone } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SseService {
  constructor(private zone: NgZone) {}

  async createEventSource() {
    // SSE connection is currently disabled
  }
}
